import type {IUserStore} from "data/stores/user/user.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {Bindings} from "data/constants/bindings";

export interface ICFLHeaderMobileController extends ViewController {
	i18n: ILocalizationStore;

	get isOpenMenu(): boolean;
	get isAuthorized(): boolean;

	set searchValue(value: string);
	get searchValue(): string;

	setIsOpenMenu: (value: boolean) => void;
	onSearch: () => void;
}

@injectable()
export class CFLHeaderMobileController implements ICFLHeaderMobileController {
	@observable private _isOpenMenu: boolean = false;
	@observable private _searchValue: string = "";

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) public i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	get isAuthorized(): boolean {
		return this._userStore.isAuthorized;
	}
	get isOpenMenu(): boolean {
		return this._isOpenMenu;
	}

	set searchValue(value: string) {
		this._searchValue = value;
	}

	get searchValue() {
		return this._searchValue;
	}

	dispose(): void {
		return;
	}

	init(): void {
		return;
	}

	setIsOpenMenu = (value: boolean) => {
		this._isOpenMenu = value;
	};

	onSearch = () => {
		const cflLink: string =
			{
				en: "https://cfl.ca/",
				fr: "https://www.lcf.ca/",
			}[this.i18n.languageOnly ?? "en"] ?? "";

		window.location.href = `${cflLink}search/?q=${this._searchValue}`;
	};
}
